exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".label{font-size:1em}table#listsDataLogs{width:100%}table#listsDataLogs th{background-color:#eee;padding:10px;font-size:1.1em}table#listsDataLogs td{padding:5px 0 5px 35px}.index_100_ddkswwwxww{width:100%;display:inline-block;position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./app/views/logs/logs.css
// module id = 237
// module chunks = 0